var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoCreateUser(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "33px",
    height: "32px",
    viewBox: "0 0 33 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 19") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    transform: "translate(-877.000000, -789.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(878.000000, 790.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4931835,24.9227295 C10.8049511,24.9227295 1.81105457,25.1727295 0.544819219,23.588501 C-0.721416133,22.0042725 0.378071172,19.7322998 2.21608387,18.0567627 C4.05409656,16.3812256 7.84022937,15.477417 9.7854198,13.237915 C10.5912551,12.3101551 7.90461696,11.4267155 7.03114734,8.92602539 C5.79616539,5.39034762 6.6189445,0.129772798 12.4931835,-2.14939178e-13",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    d: "M22.7770996,24.9227295 C21.7359294,24.9227295 17.9160779,25.017816 14.8438805,24.7190961 M12.5,18.0567627 C14.3380127,16.3812256 18.1241455,15.477417 20.0693359,13.237915 C20.8751713,12.3101551 18.1885331,11.4267155 17.3150635,8.92602539 C16.0800815,5.39034762 16.9028606,0.129772798 22.7770996,-1.08357767e-13",
    id: "Combined-Shape",
    stroke: "#FFFFFF",
    strokeWidth: 2,
    transform: "translate(17.638550, 12.468559) scale(-1, 1) translate(-17.638550, -12.468559) "
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-Copy",
    transform: "translate(17.500000, 16.500000)",
    fill: "#FFFFFF"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7,14 C3.13400675,14 0,10.8659932 0,7 C0,3.13400675 3.13400675,0 7,0 C10.8659932,0 14,3.13400675 14,7 C14,10.8659932 10.8659932,14 7,14 Z M5.9,6 L2.7,6 L2.7,8.1328125 L5.9,8.1328125 L5.9,11.3152344 L8.0328125,11.3152344 L8.0328125,8.1328125 L11.3152344,8.1328125 L11.3152344,6 L8.0328125,6 L8.0328125,2.7 L5.9,2.7 L5.9,6 Z",
    id: "Combined-Shape"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoCreateUser);
export default __webpack_public_path__ + "static/media/ico_create-user.5c3326e8b2d1bc7ea67105b004407bfe.svg";
export { ForwardRef as ReactComponent };